import { render, staticRenderFns } from "./RelatedDealersTable.vue?vue&type=template&id=666623e3"
import script from "./RelatedDealersTable.vue?vue&type=script&lang=js"
export * from "./RelatedDealersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports